import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { FinishCreditMultiStepLoadRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { FinishCreditMultiStepLoadResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const finishCreditMultiStepLoad = (request: FinishCreditMultiStepLoadRequest, options?: CashRequestOptions) =>
  post<FinishCreditMultiStepLoadRequest, FinishCreditMultiStepLoadResponse>(
    '/2.0/cash/finish-credit-multi-step-load',
    request,
    { ...options, rejectOnError: true }
  )
